<template>
  <div>
    <div
      class="sidebar_update sidebar-offcanvas left_sidebar_icon_short_cut"
      id="sidebar"
      style="left: 0px !important"
    >
      <div
        class="
          text-center
          navbar-brand-wrapper
          d-flex
          align-items-center
          justify-content-center
        "
      >
        <a class="navbar-brand brand-logo d-none" :href="logoUrl">
          <img :src="logoSrc" alt="logo" />
        </a>
        <a v-if="userId.company_id == 1" class="navbar-brand brand-logo-mini" :href="logoUrl">
          <img :src="logoIconSrc" alt="logo" />
        </a>
        <a v-else class="navbar-brand brand-logo-mini" :href="logoUrl">
          <img :src="company_logo" alt="logo" />
        </a>
      </div>

      <ul
        class="
          nav_update
          nav-scrolling_update
          icon_side_bar_update
          theme_change
        "
      >
        <li
          class="nav-item_update arrow_slected"
          v-for="(item, index) in data"
          :key="index"
          v-if="item.permission && item.priority > 0"
        >
          <div :class="item.role">
            <a
            v-if="item.name == 'Chat'"
              class="nav-link_update click_menu_function text-primary cursor-pointer"
              :data-menuid="item.id ? item.id : 'null'"
              @click.prevent="chatModalOpen()">
              <span
                class="icon-wrapper_update"
                data-toggle="tooltip"
                data-placement="top"
                :title="item.name"
              >
                <app-icon
                  :name="item.icon"
                  class="menu-icon"
                  style="color: white; font-size: 20px"
                />
              </span>
            </a>
            <a
              v-else
              class="nav-link_update click_menu_function"
              :data-menuid="item.id ? item.id : 'null'"
              @click="hideopenmenu"
              :href="item.id ? '#' + item.id : item.url"
            >
              <span
                class="icon-wrapper_update"
                data-toggle="tooltip"
                data-placement="top"
                :title="item.name"
              >
                <app-icon
                  :name="item.icon"
                  class="menu-icon"
                  style="color: white; font-size: 20px"
                />
              </span>
            </a>
            <div class="selected-view-indication active_open_arrow"></div>
            <input type="hidden" class="role_chk" :value="item.role" />
          </div>
        </li>
      </ul>
      <!-- bottom menu -->
      <div class="bottom_fixed_shortcut">
        <ul
          class="
            nav_update
            nav-scrolling_update
            icon_side_bar_update
            theme_change
          "
        >
          <li class="nav-item_update arrow_slected">
            <a style="cursor: pointer" class="nav-link_update">
              <span
                class="icon-wrapper_update"
                data-toggle="tooltip"
                data-placement="top"
                title="All Menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  @click="openMenu"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-align-justify"
                >
                  <line x1="21" y1="10" x2="3" y2="10"></line>
                  <line x1="21" y1="6" x2="3" y2="6"></line>
                  <line x1="21" y1="14" x2="3" y2="14"></line>
                  <line x1="21" y1="18" x2="3" y2="18"></line>
                </svg>
              </span>
            </a>
            <div class="selected-view-indication active_open_arrow"></div>
          </li>
          <li class="nav-item_update arrow_slected">
            <a style="cursor: pointer" class="nav-link_update">
              <span
                class="icon-wrapper_update"
                data-toggle="tooltip"
                data-placement="top"
                title="Notification"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  @click="openNav"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-bell"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                </svg>
              </span>
            </a>
            <div class="selected-view-indication active_open_arrow"></div>
          </li>
          <li class="nav-item_update">
            <a style="cursor: pointer" class="nav-link_update">
              <span class="icon-wrapper_update">
                <button
                  class="navbar-toggler align-self-center"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Theme Mode"
                  type="button"
                  @click.prevent="toggleDarkMode"
                >
                  <span v-if="darkMode" :key="'sun'" :title="$t('light_mood')">
                    <app-icon :name="'sun'" />
                  </span>
                  <span v-else :key="'moon'" :title="$t('dark_mood')">
                    <app-icon :name="'moon'" />
                  </span>
                </button>
              </span>
            </a>
          </li>
          <li class="nav-item_update">
            <a href="" class="nav-link_update profile_icon_color">
              <span class="icon-wrapper_update update_fixed_position">
                <app-navbar-profile-dropdown :user="user" :data="profileData" />
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <!-- toggle sidebar -->
      <div style="text-align: end" class="tooglebutton_hide">
        <a style="cursor: pointer;" class="nav-link_update">
          <!-- <p v-model="user" style="color: #0d1c29">{{user.full_name}} - {{user.role}}</p> -->
          <span class="icon-wrapper_update toogle_icon_color">
            <button class="navbar-toggler align-self-center" type="button">
              <span
                v-if="leftMenuType === 'normal'"
                :key="'align-left'"
                @click.prevent="togglingLeftMenu('active-icon-only-menu')"
                :title="$t('collapse_sidebar')"
              >
                <app-icon :name="'chevrons-left'" />
              </span>
              <span
                v-else-if="leftMenuType === 'icon-only'"
                :key="'align-center'"
                @click.prevent="togglingLeftMenu('active-floating-menu')"
                :title="$t('floating_sidebar')"
              >
                <app-icon :name="'chevrons-right'" />
              </span>
              <span
                v-else-if="leftMenuType === 'floating'"
                :key="'align-justify'"
                @click.prevent="togglingLeftMenu('active-normal-menu')"
                :title="$t('full_sidebar')"
              >
                <app-icon :name="'chevrons-right'" />
              </span>
            </button>
          </span>
        </a>
      </div>
      <!-- toggle sidebar End  -->

      <!-- All Menu -->
      <ul class="nav nav-scrolling adminmenu_all" v-if="allMenu == true">
        <!-- testing sidebar -->
        <li
          class="nav-item mobile_menu_title_hide"
          v-for="(item, index) in data"
          :key="index"
          v-if="item.permission && item.priority > 0"
        >
          <div :class="item.role">
            <a
              class="nav-link"
              :href="item.id ? '#' + item.id : item.url"
              :data-toggle="item.id ? 'collapse' : false"
              :aria-expanded="item.id ? 'false' : false"
              :aria-controls="item.id ? item.id : false"
            >
              <span class="icon-wrapper">
                <app-icon
                  :name="item.icon"
                  class="menu-icon"
                  style="
                    color: var(--side-bar-dark-text-color);
                    font-size: 20px;
                  "
                />
              </span>
              <span class="menu-title">{{ item.name }}</span>
              <i v-if="item.subMenu" class="menu-arrow" />
            </a>
            <input type="hidden" class="role_chk" :value="item.role" />
            <div
              class="collapse allsubmenu_display"
              v-if="item.subMenu"
              :id="item.id"
            >
              <ul class="nav flex-column sub-menu">
                <li
                  class="nav-item"
                  v-for="(submenuItem, index) in item.subMenu"
                  :key="index"
                  v-if="
                    submenuItem.permission === true ||
                    submenuItem.permission === ''
                  "
                >
                  <a class="nav-link" :href="submenuItem.url">
                    {{ submenuItem.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- end testinbg sidebar -->
        <li
          class="nav-item"
          v-for="(item, index) in data"
          :key="index"
          v-if="item.permission && item.priority == 0"
        >
          <div :class="item.role">
            <a
              class="nav-link"
              :href="item.id ? '#' + item.id : item.url"
              :data-toggle="item.id ? 'collapse' : false"
              :aria-expanded="item.id ? 'false' : false"
              :aria-controls="item.id ? item.id : false"
            >
              <span class="icon-wrapper">
                <app-icon
                  :name="item.icon"
                  class="menu-icon"
                  style="
                    color: var(--side-bar-dark-text-color);
                    font-size: 20px;
                  "
                />
              </span>
              <!-- :href="item.menulink" -->
              <a  v-if="item.menulink" :href="item.menulink">
                <span class="menu-title" @click="locationall(item)">{{
                  item.name
                }}</span>
              </a>
              <span class="menu-title" @click="shortNavigation(item)" v-else-if="!item.subMenu">{{ item.name }}</span>
              <span class="menu-title" v-else>{{ item.name }}</span>
              <i v-if="item.subMenu" class="menu-arrow" />
            </a>
            <input type="hidden" class="role_chk" :value="item.role" />
            <div
              class="collapse allsubmenu_display"
              v-if="item.subMenu"
              :id="item.id"
            >
              <ul class="nav flex-column sub-menu">
                <li
                  class="nav-item"
                  v-for="(submenuItem, index) in item.subMenu"
                  :key="index"
                  v-if="
                    submenuItem.permission === true ||
                    submenuItem.permission === ''
                  "
                >
                <!-- :href="submenuItem.url" -->
                  <a class="nav-link" @click="shortNavigation(submenuItem)" :href="submenuItem.url">
                    {{ submenuItem.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <!-- All menu end -->

      <!-- Submenu -->
      <ul
        class="nav nav-scrolling adminmenu_all_ submenu_items"
        v-if="allMenu == false"
      >
        <li
          class="nav-item submenu_show"
          v-for="(item, index) in data"
          :key="index"
          v-if="item.permission"
        >
          <div :class="item.role">
            <input type="hidden" class="role_chk" :value="item.role" />
            <div
              class="submenu_id_chk"
              v-if="item.subMenu"
              :id="item.id"
              :data-submenuid="item.id ? item.id : ''"
            >
              <ul class="nav flex-column sub-menu">
                <li
                  class="nav-item"
                  v-for="(submenuItem, index) in item.subMenu"
                  :key="index"
                  v-if="
                    submenuItem.permission === true ||
                    submenuItem.permission === ''
                  "
                >
                  <a class="nav-link" @click="shortNavigation(submenuItem)" :href="submenuItem.url">
                    {{ submenuItem.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </nav>

    <!-- notification start here -->

    <div id="mySidenav" class="mysidenav">
      <div class="container">
        <div class="row py-4">
          <div class="col-lg-12">
            <h4 class="mb-0">Notification</h4>
          </div>
        </div>
      </div>
      <a href="javascript:void(0)" class="closebtn" @click="closeNav"
        >&times;</a
      >
      <div>
        <div class="text-justify">
          <div class="mb-primary">
            <notification-index></notification-index>
          </div>
        </div>
      </div>
    </div>
    <!-- notification End -->
    <chat-modal
      v-if="chatModalActive"
      @close-modal="closeChatModal"
    />
  </div>
</template>

<script>
import ThemeMixin from "../../mixins/global/ThemeMixin";
import CoreLibrary from "../../helpers/CoreLibrary";
import AppFunction from "../../helpers/app/AppFunction";
import { GET_LOGIN_COMPANY_LOGO } from "../../../app/Config/ApiUrl";
import PerfectScrollbar from "perfect-scrollbar";
// import {UserMixin} from '../../../app/Components/Views/Auth/Mixins/UserMixin';

export default {
  name: "Sidebar",
  mixins: [ThemeMixin],
  extends: CoreLibrary,
  components: {},
  // mixins: [UserMixin],

  props: {
    user: {
      type: Object,
      require: true,
    },
    profileData: {
      type: Array,
      require: true,
    },
    data: {
      type: Array,
      required: true,
    },
    logoSrc: {
      type: String,
      default: AppFunction.getAppUrl("images/core.png"),
    },
    logoIconSrc: {
      type: String,
      default: AppFunction.getAppUrl("images/core.png"),
    },
    logoUrl: {
      type: String,
      default: "/",
    },
    menuShow: false,
    itemType: null,
  },
  data() {
    return {
      company_logo: '',
      chatModalActive: false,
      allMenu: false,
      fullScreen: false,
      leftMenuType: "normal",
      darkMode: false,
      icon: "settings",
      tabsHorizontal: [
        {
          // "icon": "lock",
          name: "All",
          component: "app-notification-all",
          permission: "",
        },
        {
          name: "Unread",
          component: "app-notification-all",
          permission: "",
        },
        {
          name: "I was mentioned",
          component: "app-notification-all",
          permission: "",
        },
        {
          name: "Assigned to me",
          component: "app-notification-all",
          permission: "",
        },
      ],
    };
  },

  watch: {
    leftMenuType: function () {
      let htmlElement = document.documentElement;

      if (this.leftMenuType === "normal") {
        localStorage.setItem("sidebar", "normal");
        htmlElement.setAttribute("sidebar", "normal");
      } else if (this.leftMenuType === "icon-only") {
        localStorage.setItem("sidebar", "icon-only");
        htmlElement.setAttribute("sidebar", "icon-only");
      } else {
        localStorage.setItem("sidebar", "floating");
        htmlElement.setAttribute("sidebar", "floating");
      }
    },
  },
  mounted() {

    this.companyLogo();
    this.allMenu = true;
    this.$nextTick(function () {
      let body = $("body"),
        current = location.pathname,
        sidebar = $(".sidebar"),
        sidebarType = localStorage.getItem("sidebar");
      $(function () {
        // Add active class to nav-link based on url dynamically
        function addActiveClass(element) {
          if (element.attr("href").indexOf(current) !== -1) {
            element.parents(".nav-item").last().addClass("active");
            if (sidebarType === "floating") {
              if (element.parents(".sub-menu").length) {
                element.closest(".collapse").removeClass("show");
                element.addClass("active");
              }
              if (element.parents(".submenu-item").length) {
                element.addClass("active");
              }
            } else {
              if (element.parents(".sub-menu").length) {
                element.closest(".collapse").addClass("show");
                element.addClass("active");
              }
              if (element.parents(".submenu-item").length) {
                element.addClass("active");
              }
            }
          }
        }
        $(".nav li a", sidebar).each(function () {
          let $this = $(this);
          addActiveClass($this);
        });
        $(".horizontal-menu .nav li a").each(function () {
          let $this = $(this);
          addActiveClass($this);
        });
        // Close other submenu in sidebar on opening any
        sidebar.on("show.bs.collapse", ".collapse", function () {
          sidebar.find(".collapse.show").collapse("hide");
        });
        // Change sidebar and content-wrapper height
        applyStyles();
        function applyStyles() {
          //Applying perfect scrollbar
          if (!body.hasClass("rtl")) {
            if (body.hasClass("sidebar-fixed")) {
              let fixedSidebarScroll = new PerfectScrollbar("#sidebar .nav");
            }
          }
        }
      });
      // Sidebar collapse menu on hover
      $(document).on(
        "mouseenter mouseleave click",
        ".sidebar .nav-item",
        function (ev) {
          let body = $("body");
          let sidebarIconOnly = body.hasClass("sidebar-icon-only");
          let sidebarFixed = body.hasClass("sidebar-fixed");
          if (sidebarIconOnly) {
            if (sidebarFixed) {
              if (ev.type === "mouseenter") {
                body.removeClass("sidebar-icon-only");
              }
            } else {
              let $menuItem = $(this);
              if (ev.type === "mouseenter") {
                $menuItem.addClass("hover-open");
              } else if (ev.type === "click") {
                $menuItem.addClass("hover-open");
              } else {
                $menuItem.removeClass("hover-open");
              }
            }
          }
        }
      );
      // Close collapse menu when mouse leave from sidebar hover only
      $(document).on(
        "mouseenter mouseleave",
        ".sidebar-hover-only .sidebar",
        function (ev) {
          if (ev.type === "mouseleave") {
            $(".sidebar").find(".collapse.show").collapse("hide");
          } else {
          }
        }
      );
    });
    // Check for active theme
    let body = $("body"),
      htmlElement = document.documentElement,
      theme = localStorage.getItem("theme"),
      sidebar = localStorage.getItem("sidebar");

    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
      this.$store.state.theme.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
      this.$store.state.theme.darkMode = false;
    }

    if (sidebar === "normal") {
      localStorage.setItem("sidebar", "normal");
      htmlElement.setAttribute("sidebar", "normal");
      body.removeClass("sidebar-icon-only");
      body.removeClass("sidebar-hover-only");
      this.leftMenuType = "normal";
    } else if (sidebar === "icon-only") {
      localStorage.setItem("sidebar", "icon-only");
      htmlElement.setAttribute("sidebar", "icon-only");
      body.removeClass("sidebar-hover-only");
      body.toggleClass("sidebar-icon-only");
      this.leftMenuType = "icon-only";
    } else if (sidebar === "floating") {
      localStorage.setItem("sidebar", "floating");
      htmlElement.setAttribute("sidebar", "floating");
      body.removeClass("sidebar-icon-only");
      body.toggleClass("sidebar-hover-only");
      $(".sidebar").find(".collapse.show").collapse("hide");
      this.leftMenuType = "floating";
    }
    $(function () {
      $("body").removeClass("bg_registration_graph");
      $(".arrow_slected").click(function () {
        $(".arrow_slected").removeClass("open_now");
        // $('#mySidenav').css("width", "0px");
        $(this).addClass("open_now");
      });
    });

    $(function () {
      //ready function
      $(".click_menu_function").click(function () {
        //  menu_id = $(this).data('menuid');
        var theValue = $(this).data("menuid");
        // var rex = new RegExp(theValue);
        // alert(theValue);
        if (theValue) {
          $(".submenu_id_chk").hide();

          $(".submenu_id_chk" + "#" + theValue)
            .filter(function () {
              return $(this).text();
            })
            .show();
        } else if (theValue == null) {
          $(".submenu_id_chk").hide();
          $(".arrow_slected").removeClass("open_now");
          $(".selected-view-indication").removeClass("active_open_arrow");
        } else {
          
          $(theValue).val("");
          $(".submenu_id_chk").show();
        }
        // $('.dropdown ul.on').removeClass("on");
      });

      // function clearFilter()
      // {
      //   $('.filterFloorplans').val('');
      //   $('.unit').show();
      // }

      // $('.selectBedrooms').click(function () {
      //   $('.dropdown ul').toggleClass("on");
      // });

      // $('.adminmenu_all .nav-item').click(function(){
      //    let removedisplaynone = $('.adminmenu_all .nav-item .allsubmenu_display');
      //    if($(removedisplaynone).hasClass('show'))
      //    {
      //       removedisplaynone.show();
      //    }
      //    else{
      //       removedisplaynone.hide();
      //    }
      // });
    });
  },

  methods: {
    locationall(item) {
      // alert("asdsad");
      window.location = "/admin/membership/all";
      item.url = "/admin/membership/all";
      this.shortNavigation(item);
    },
    hideopenmenu() {
      this.allMenu = false;
    },
    sendNotification(notification) {
      this.$emit("clicked", notification);
    },
    sidebarOffcanvas() {
      $(".sidebar-offcanvas").toggleClass("active");
    },
    openMenu() {
      this.allMenu = true;
    },
    togglingLeftMenu(action) {
      let body = $("body");

      if (action === "active-icon-only-menu") {
        body.removeClass("sidebar-hover-only");
        body.toggleClass("sidebar-icon-only");
        this.leftMenuType = "icon-only";
      } else if (action === "active-floating-menu") {
        body.removeClass("sidebar-icon-only");
        body.toggleClass("sidebar-hover-only");
        $(".sidebar").find(".collapse.show").collapse("hide");
        this.leftMenuType = "floating";
      } else if (action === "active-normal-menu") {
        body.removeClass("sidebar-icon-only");
        body.removeClass("sidebar-hover-only");
        this.leftMenuType = "normal";
      }
    },
    closeNav() {
      $("#mySidenav").css("width", "0px");
      
      // document.getElementById("mySidenav").style.width = "0";
      $(".arrow_slected").removeClass("open_now");
    },
    openNav() {
      $("#mySidenav").css("width", "700px");
    },
    buyerClick(item) {
      this.menuShow = true;
      this.itemType = item;
    },
    chatModalOpen() {
      this.chatModalActive = true;
    },
    closeChatModal() {
      this.chatModalActive = false;
    },
    shortNavigation(item) {
      var shortNavs = JSON.parse(localStorage.getItem("shortCutNavigation") || "[]");
      var statue = true;
      var staticList = ['Dashboard','My Document','Tasks', 'Certificates']
      if (!staticList.includes(item.name)) {
        if(shortNavs.length > 0) {
          shortNavs.forEach(function(Nav, index) {
            if (item.name == Nav.name) {
                shortNavs[index] = {...Nav,count: Nav.count +1};
                statue = false;
                localStorage.setItem("shortCutNavigation", JSON.stringify(shortNavs));
            }
          });
            if(statue) {
              var shortNav = { "name": item.name, "url": item.url, "count": 1, "user_id": this.userId.id};
              shortNavs.push(shortNav);
              localStorage.setItem("shortCutNavigation", JSON.stringify(shortNavs));
            }
        }
        else {
          var shortNav = { "name": item.name, "url": item.url, "count": 1, "user_id": this.userId.id};
          shortNavs.push(shortNav);
          localStorage.setItem("shortCutNavigation", JSON.stringify(shortNavs));
        }
      }
    },
    companyLogo() 
    {
      // alert('done');
      this.axiosGet(GET_LOGIN_COMPANY_LOGO)
        .then((response) => {
          this.company_logo = response.data.logo ?? '../images/ulogo.png';

        })
        .catch((error) => {
          
        });

    }
  },
  computed: {
    userId() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
 